var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table-list 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1042 0.708344H3.89583C1.74817 0.708344 0 2.4558 0 4.60418V11.6875C0 13.8359 1.74817 15.5833 3.89583 15.5833H13.1042C15.2518 15.5833 17 13.8359 17 11.6875V4.60418C17 2.4558 15.2518 0.708344 13.1042 0.708344ZM2.125 7.08334H4.25V9.20834H2.125V7.08334ZM6.375 7.08334H14.875V9.20834H6.375V7.08334ZM14.875 4.60418V4.95834H6.375V2.83334H13.1042C14.081 2.83334 14.875 3.62809 14.875 4.60418ZM3.89583 2.83334H4.25V4.95834H2.125V4.60418C2.125 3.62809 2.91904 2.83334 3.89583 2.83334ZM2.125 11.6875V11.3333H4.25V13.4583H3.89583C2.91904 13.4583 2.125 12.6636 2.125 11.6875ZM13.1042 13.4583H6.375V11.3333H14.875V11.6875C14.875 12.6636 14.081 13.4583 13.1042 13.4583Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.6d3e2b3b57b003b5eea1fa7cfd64e22a.svg";
export { ForwardRef as ReactComponent };